import { Stack } from "@mui/material";
import SwitchControl from "components/form/SwitchControl";
import useIsCreate from "hooks/useIsCreate";
import { useFormContext } from "react-hook-form";
import { ReportInputs } from "../types";

const ReportSwitch = () => {
  const isCreate = useIsCreate();
  const form = useFormContext<ReportInputs>();
  const isSendResult = form.watch("isSendResult");

  return (
    <Stack
      direction='row'
      flexWrap='wrap'>
      <SwitchControl
        name='isSendResult'
        label='Отправлять отчет кандидату'
        tooltipTitle={isSendResult ? "Отчет будет доступен кандидату по\u00A0завершении тестирования" : undefined}
        disabled={!isCreate}
      />
      {isSendResult && (
        <SwitchControl
          name='isExtendedReport'
          label='Отправлять кандидату расширенный отчет'
          disabled={!isCreate}
        />
      )}
    </Stack>
  );
};

export default ReportSwitch;
